import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={14}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.48 13.375q-.56 0-.958-.397a1.3 1.3 0 0 1-.397-.958V2.5h-.75V1.375H3.75V.712h4.5v.663h3.375V2.5h-.75v9.52q0 .567-.394.962a1.3 1.3 0 0 1-.962.393zM9.75 2.5h-7.5v9.52q0 .1.065.165a.23.23 0 0 0 .166.065h7.038a.22.22 0 0 0 .159-.072.22.22 0 0 0 .072-.159zm-5.697 8.25h1.125V4H4.053zm2.77 0h1.124V4H6.822z"
      fill="#707070"
    />
  </svg>
);
export default SVGComponent;
